import { Injectable, Signal, inject } from '@angular/core';
import { Params } from '@angular/router';
import { APP_ACTIONS, type AppActionsApi } from '@app/core/app.actions';
import { RxState } from '@rx-angular/state';
import {
  MovementDetail,
  VesselMovement,
  VesselReport,
  VesselReportPagination,
  VesselReportPort,
  VesselSchedule
} from '@vessel-reports/state/vessel-reports.types';

interface IVesselReportsState {
  pagination: VesselReportPagination;
  vesselReportPorts: VesselReportPort[];
  vesselReportPortsPagination: VesselReportPagination;
  searchedVesselReports: VesselReport[];
  vesselReports: VesselReport[];
  vesselReport: VesselReport;
  previousVesselReport: VesselReport;
  vesselMovements: VesselMovement[];
  portcall: any;
  detailNoonReport: any;

  vesselSchedule: VesselSchedule;
  selectedMovementDetail: MovementDetail;

  etaFilter: 'all' | '3m' | 'yd' | 'custom' | null;
  queryParams: Params;
  openedSidebarDrawer: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class VesselReportsState extends RxState<IVesselReportsState> {
  protected readonly appActions: AppActionsApi = inject(APP_ACTIONS);

  pagination: Signal<VesselReportPagination> = this.signal('pagination');
  vesselReportPorts: Signal<VesselReportPort[]> = this.signal('vesselReportPorts');
  vesselReportPortsPagination: Signal<VesselReportPagination> = this.signal('vesselReportPortsPagination');
  vesselReports: Signal<VesselReport[]> = this.signal('vesselReports');
  vesselReport: Signal<VesselReport> = this.signal('vesselReport');
  detailNoonReport: Signal<VesselReport> = this.signal('detailNoonReport');
  previousVesselReport: Signal<VesselReport> = this.signal('previousVesselReport');
  vesselMovements: Signal<VesselMovement[]> = this.signal('vesselMovements');
  portcall: Signal<any> = this.signal('portcall');

  vesselSchedule: Signal<VesselSchedule> = this.signal('vesselSchedule');
  selectedMovementDetail: Signal<MovementDetail> = this.signal('selectedMovementDetail');

  etaFilter: Signal<'all' | '3m' | 'yd' | 'custom' | null> = this.signal('etaFilter');
  queryParams: Signal<Params> = this.signal('queryParams');
  openedSidebarDrawer: Signal<boolean> = this.signal('openedSidebarDrawer');

  constructor() {
    super();
    this.hold(this.appActions.resetAll$, () => {
      this.reset();
    });
    this.set({ vesselReports: [], vesselReportPorts: [], vesselMovements: [], queryParams: null, openedSidebarDrawer: true });
  }

  // Clear all vessel reports related state
  reset(): void {
    this.set({
      pagination: null,
      vesselReportPorts: [],
      vesselReportPortsPagination: null,
      searchedVesselReports: [],
      vesselReports: [],
      vesselReport: null,
      previousVesselReport: null,
      vesselMovements: [],
      portcall: null,
      vesselSchedule: null,
      selectedMovementDetail: null,
      etaFilter: null,
      queryParams: null,
      openedSidebarDrawer: true
    });
  }
}
